import React, { useEffect } from 'react';

function ScrollToTop({ tab }) {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }, [tab])

    return null
}

export default ScrollToTop;